import React, { useState } from "react";
import { head, logos, tshirt1 } from "../assets/img";
import UnsubscribeIcon from "@mui/icons-material/Unsubscribe";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import CircleIcon from "@mui/icons-material/Circle";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import {  useLocation } from "react-router-dom";

import {useApproveandrejectMutation } from "../redux/api/api";

const PoProductRequestA = () => {
  const [state, setstate] = useState ("");
  const location = useLocation();
  const [address,setAddress]=useState("")
  const [dimension,setDimension]=useState("")
   const[user_comment,setUser_comment] =useState("") 
   const item = location?.state?.item; 
    const projectId = item?.project_id;
   const [approveApi]=useApproveandrejectMutation();

  const myfun = (type) => {
    setstate(type);
  };

  console.log("state", state);
  const submitHandler = () => {
    let formdata = new FormData();
    
    formdata.append("project_detail_id", projectId);
    formdata.append("artwork_status", 3);
    formdata.append("location", address);
    formdata.append("dimension", dimension);
    formdata.append("user_comment", user_comment);


    // dispatch(saveLoader(true));
    approveApi(formdata)
      .unwrap()
      .then((res) => {
        // toast.success(res?.message);
        // dispatch(saveLoader(false));
        // setBtns(false);
      })
      .catch((err) => {
        // dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  return (
    <div className="bg-white" style={{ backgroundColor: "#fff" }}>
      <div className=" " style={{ width: "90%", margin: "auto" }}>
        <div className="d-flex flex-wrap">
          <div
            className="d-flex flex-wrap align-items-center mt-3 py-2 banner col-md-5"
            style={{ backgroundColor: "#ecfaff", borderRadius: "20px" }}
          >
            <div className="">
              <img
                alt="img"
                src={logos}
                className=" ps-3"
                style={{ width: "150px", objectFit: "cover" }}
              />
            </div>

            <div className="ps-2 font-blue2 ">
              <h2 className="f4 fs-xs-11 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20">
                MerchHQ Pvt.Ltd.
              </h2>
              <p className="f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18">
                Approval for 5SK supplier
              </p>
              <p className="f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16">
                PRESENTATION LIST #330070
              </p>
            </div>
          </div>
          <div className="col-md-7 mt-3">
            <img alt="img" src={head} className="ps-lg-3 w-100" />
          </div>
        </div>
        <div className="my-3">
          <p className="f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16">
            Important! Please read the following carefully.
          </p>
          <p className="f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16">
            By approving the Purchase order, you are acknowledging you have
            thoroughly reviewed all of the following aspects of this order:
          </p>
        </div>
        <div className="d-flex flex-wrap my-2">
          <div className="col-md-6">
            <p className="f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16">
              - Quantities
            </p>
            <p className="f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16">
              - Size Breakdowns
            </p>
            <p className="f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16">
              - Product colors
            </p>
          </div>
          <div className="col-md-6">
            <p className="f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16">
              - Imprint Colors
            </p>
            <p className="f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16">
              - Decoration Methods
            </p>
            <p className="f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16">
              - Artwork (including spelling)
            </p>
          </div>
        </div>
        <div>
          <p className="f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 my-2">
            Please fill out the form below to put the order into production.
          </p>
          <div className="d-flex flex-wrap ">
            <div className="col-md-6">
              <p className="f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 my-2">
                Your Name:
              </p>
              <input
                className="p-2 bg-lt-blue3 border-0 rounded w-70"
                placeholder="Enter your full name"
              ></input>
            </div>
            <div className="col-md-6">
              <p className="f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 my-2">
                Change Purchase Order status to:
              </p>
              <div className="d-flex  my-2 " >
                <div className="d-flex ac-jc ">
                  <div
                    onClick={()=>setstate(1)}
                    className={`pointer ${state == 1 ? "green1" : "gray"}`}
                  >
                    <CircleIcon />
                  </div>
                  <span className="gray ps-1">Approved</span>
                </div>
                <div className="d-flex ac-jc ">
                  <div
                    onClick={()=>setstate(2)}
                    className={`pointer ms-3 ${state == 2 ?  "err" : "gray"}`}
                  >
                    <CircleIcon />
                  </div>
                  <span className="gray ps-1">Change Required</span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="font-blue2">
              <p className="f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 my-2">
                Additional Notes:
              </p>
              <textarea
                className="p-2 bg-lt-blue3 border-0 rounded w-100 "
                placeholder="Enter your Additional Notes  "
              ></textarea>
            </div>
          </div>
        </div>
        <div className="d-flex ac-jc">
          <button
            class=" d-flex px-3 mt-sm-2 "
            style={{
              backgroundColor: "#07679c",
              border: "none",
              borderRadius: "7px",
              padding: "5px",
              color: "#fff",
            }}
          >
            <p className="f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 white">
              Submit
              <PlaylistAddCheckIcon />
            </p>
          </button>
        </div>
      </div>
      <div className="">
        <div
          className="mt-3  px-4"
          style={{
            backgroundColor: "#07679c",
            padding: "20px",
            lineHeight: "30px",
          }}
        >
          <div className="w-90 m-auto d-flex flex-wrap ac-jb">
            <div className="">
              <h2 className="f4 fs-xs-12 fs-sm-13 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 white">
                Roger Daniel
              </h2>
              <a className="f1 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 lt-Blue">
                roger@companystore.io
              </a>
              <button
                class=" d-flex ac-jc ps-3 mt-4"
                style={{
                  backgroundColor: "#0082ca",
                  border: "none",
                  borderRadius: "7px",
                  padding: "5px",
                  color: "#fff",
                }}
              >
                <UnsubscribeIcon />

                <p className="f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 white">
                  Contact us
                </p>
              </button>
            </div>
            <div className="col-md-4">
              <p className="f3 fs-xs-12 fs-sm-14 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18 white">
                merchHQ Pvt.Ltd.
              </p>
              <p className="f1 fs-xs-11 fs-sm-12 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 white w-70 ">
                #39 Krishna Reddy Colony, Domlur Layout Banglore- 560071
                Kartnataka, India.
              </p>
              <div class="d-flex white mt-sm-2 ">
                <FacebookRoundedIcon className="me-2" />

                <TwitterIcon className="mx-2" />

                <LinkedInIcon className="mx-2" />

                <InstagramIcon className="mx-2" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoProductRequestA;
